//import axios from 'axios';
import axios from '../utils/axios';
const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";

//Clinic Recalls
const getClinicSettings = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/recalls/settings")
}
const saveSettings = (clinicId,data) =>{
    return axios.post(API_URL+"clinics/"+clinicId+"/recalls/settings",data)
}
const getClinicTimings= (clinicId) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/recalls/recall-timings")
}
const saveClinicTimings= (clinicId,data) =>{
    return axios.post(API_URL+"clinics/"+clinicId+"/recalls/recall-timings",data)
}

//Admin Recalls

const getRecalls = (pageNo=0,pageSize=5) =>{
    return axios.get(API_URL+"recalls/requests?pageNo="+pageNo+"&pageSize="+pageSize)
}
const getRecallsById = (recallId) =>{
    return axios.get(API_URL+"recalls/requests/"+recallId)
}
const updateRecall = (recallId,data)=>{
    return axios.put(API_URL+"recalls/requests/"+recallId,data)
}

const fileDownload = (fileUrl) =>{
    return  axios.get(fileUrl, {
        responseType: 'blob', // Specify responseType as blob
      })
}
export default {
   getClinicSettings,
   saveSettings,
   getClinicTimings,
   saveClinicTimings,
   getRecalls,
   getRecallsById,
   updateRecall,
   fileDownload,

}